var module = angular.module('octopusApp.projects');


module.directive('octoDisableLink', function() {
  return function(scope, element, attr) {
    var isLoaded = false;

    element.click(function (e) {
      if (!isLoaded) {
        e.preventDefault();
        return false;
      }
    });
    scope.$watch(attr.octoDisableLink, function octoDisableLinkWatch(value) {
      isLoaded = value;
    });
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/octo_disable_link.js
// module id = 543
// module chunks = 1